import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useBonusRules, useCompanies, useTeams } from '../../../hooks';
import { SCREENS } from '../../../constants/permissions';
import AddIcon from '@mui/icons-material/Add';

const buildFormFields = (fields, additionalData, isRootUser) => {
  const teamList = additionalData?.teams?.teams || [];
  const companyList = additionalData?.companies?.companies || [];

  return fields
    .map((f) => {
      if (f.name === 'companyId') {
        return {
          ...f,
          options: companyList.map((c) => ({ value: c.id, label: c.name })),
          showIf: () => isRootUser,
        };
      }
      if (f.name === 'team_ids') {
        return {
          ...f,
          options: teamList.map((t) => ({ value: t.id, label: t.name })),
        };
      }
      return f;
    })
    .filter((f) => (f.name === 'companyId' ? isRootUser : true));
};

const PrimKurallariPage = () => (
  <DynamicCrudPage
    entityType="bonusRules"
    screen={SCREENS.PRIM_MANAGEMENT}
    hook={useBonusRules}
    additionalHooks={{ companies: useCompanies, teams: useTeams }}
    addButtonTextKey="bonusRules.actions.add"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="bonusRules"
    customFormFields={buildFormFields}
  />
);

export default PrimKurallariPage;
